var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('psp-errors-filter',{attrs:{"action":_vm.filterAction}}),(_vm.$can('read', 'transaction'))?_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }